import React from 'react';
import './Testimonials.css';

const TESTIMONIALS = [
  {
    text: "Shine People Trust changed my daughter's life. She now studies at a government school with full scholarship support. I never imagined this was possible for our family.",
    name: 'Meena Selvam',
    role: 'Mother, Villupuram District',
    initial: 'M',
    stars: 5,
  },
  {
    text: "Their women's empowerment program gave me the confidence and skills to start my own tailoring business. Today I support my entire family independently.",
    name: 'Priya Rajan',
    role: 'Entrepreneur, Tirunelveli',
    initial: 'P',
    stars: 5,
  },
  {
    text: "The free health camp in our village detected my father's diabetes early. The doctors gave medicine and guidance that we couldn't afford otherwise. Truly life-saving.",
    name: 'Karthik Murugan',
    role: 'Beneficiary, Salem',
    initial: 'K',
    stars: 5,
  },
  {
    text: "As a volunteer, I've seen firsthand the impact of their programs. The dedication of the team is remarkable — they work tirelessly for every single family.",
    name: 'Deepa Nair',
    role: 'Volunteer Coordinator',
    initial: 'D',
    stars: 5,
  },
  {
    text: "Our farming cooperative has grown 40% in yield after their soil training and rainwater harvesting installation. The entire village benefits from this knowledge.",
    name: 'Ramu Pillai',
    role: 'Farmer, Dindigul',
    initial: 'R',
    stars: 5,
  },
  {
    text: "I donated for the first time last year and the impact report I received gave me full clarity on how my contribution was used. Completely transparent and trustworthy.",
    name: 'Anand Krishnan',
    role: 'Regular Donor, Chennai',
    initial: 'A',
    stars: 5,
  },
];

const PARTNERS = [
  'UNICEF India', 'CSR India', 'GIZ', 'Tata Trusts', 'NABARD', 'HelpAge India',
];

export default function Testimonials() {
  return (
    <>
      <section className="testimonials section" aria-labelledby="testimonials-heading">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Voices of Impact</span>
            <h2 className="section-title" id="testimonials-heading">Stories That Inspire Us</h2>
            <p className="section-subtitle">
              Real people, real change. Hear from the communities, volunteers, and donors who are part of our journey.
            </p>
          </div>

          <div className="testimonials-track-wrap">
            <div className="testimonials-grid" role="list">
              {TESTIMONIALS.map(t => (
                <blockquote className="testimonial-card" key={t.name} role="listitem" cite="#">
                  <div className="testimonial-quote" aria-hidden="true">&ldquo;</div>
                  <p className="testimonial-text">{t.text}</p>
                  <div className="testimonial-author">
                    <div className="testimonial-avatar" aria-hidden="true">{t.initial}</div>
                    <div>
                      <div className="testimonial-name">{t.name}</div>
                      <div className="testimonial-role">{t.role}</div>
                    </div>
                  </div>
                  <div className="testimonial-stars" aria-label={`${t.stars} out of 5 stars`}>
                    {Array.from({ length: t.stars }, (_, i) => (
                      <span key={i} aria-hidden="true">★</span>
                    ))}
                  </div>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="partners" aria-label="Our partners and collaborators">
        <div className="container">
          <div className="partners-label">Trusted by Leading Organizations</div>
          <div className="partners-logos" role="list">
            {PARTNERS.map(p => (
              <div className="partner-logo" key={p} role="listitem">{p}</div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
